import React from "react";
import styled from "styled-components";

import { useCartContext } from "../context/CartContext";
import { useRecommendationContext } from "../context/RecommendationContext";
import { formatPrice } from "../utils/helpers";
import DropDown from "./Dropdown";
import UnderlineTextButton from "./UnderlineTextButton";

const CartItem = (props: any) => {
  const { className, id, brand, name, price, quantity, category, imageUrl } =
    props;
  const { getStyleRecommendation } = useRecommendationContext();

  const { cartItems, removeItem } = useCartContext();

  const onRemoveItemClick = () => {
    removeItem(id, brand, name, price, quantity, category, imageUrl);
    getStyleRecommendation(
      cartItems.filter((item) => item.id !== id).map((item: any) => item.id)
    );
  };

  return (
    <Wrapper className={className}>
      <div className="productImage">
        <img src={imageUrl} alt={name} />
      </div>
      <div className="productInfo">
        {`${brand} ${name}`}
        <div className={"rowContainer"}>
          <DropDown
            className={"dropDown"}
            label={"Size"}
            value={category === "Shoes" ? 8 : "M"}
          ></DropDown>
          <DropDown
            className={"dropDown"}
            label={"Quantity"}
            value={quantity}
          ></DropDown>
        </div>
        <div className={"rowContainer"}>
          <UnderlineTextButton
            className={"textButton"}
            label={"Move to Favorites"}
          ></UnderlineTextButton>
          <UnderlineTextButton
            className={"textButton"}
            label={"Remove"}
            onClick={onRemoveItemClick}
          ></UnderlineTextButton>
        </div>
      </div>
      <div className="productPrice">{formatPrice(price)}</div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 3fr 8fr 1fr;

  .rowContainer {
    display: flex;
  }

  .dropDown {
    margin-right: 40px;
  }

  .textButton {
    margin-right: 40px;
  }

  .productImage {
    max-height: 220px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      background: #f5f5f5;
    }
  }

  .productInfo {
    padding-left: 4rem;
  }

  .productPrice {
  }
`;

export default CartItem;
